'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = canPlayListener;

var _actions = require('../../store/actions');

var _store = require('../../store');

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: Delete `next` and `state` when migrated across
/*
 * Copyright 2016 hudl
 * All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @providesModule defaultCanPlayListener
 * 
 */

/*
 * The `canPlay` listener is called when the video is able to start playing.
 * This means metadata has been loaded, and enough of the fragments is loaded
 * to begin playing.
 *
 * Here we let the player know that we are no longer loading, and setting the
 * `canPlay` flag to true for other parts of the app that depend on the video
 * to be ready.
 */

function canPlayListener(state, next, playerId) {
  var _Store$storeInstance = _store2.default.storeInstance(),
      dispatch = _Store$storeInstance.dispatch;

  // If an ad just finished, begin playing the video


  var player = _store2.default.storeInstance().getState().players[playerId];
  if (player) {
    if (player.adEnded) {
      dispatch((0, _actions.setAdEnded)(playerId, false));
      dispatch((0, _actions.play)(playerId));
    } else if (player.switchingStreams >= 0) {
      dispatch((0, _actions.play)(playerId));
      dispatch((0, _actions.setCurrentTimeMs)(playerId, player.switchingStreams));
      dispatch((0, _actions.setSwitchingStreams)(playerId, -1));
    }
  }

  dispatch((0, _actions.setCanPlay)(playerId, true));
}
module.exports = exports['default'];